module.exports = __webpack_public_path__ + "static/assets/60a8d2a9f1fb09d11e710ada9dd48d91.png";